import { createContext } from 'react';

const LoadingContext = createContext(null);

export default LoadingContext;
